import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement
} from 'chart.js';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { FaBell, FaCheckCircle, FaCog } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom'; // Eliminat - nu era folosit
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import MicrophoneChart from './MicrophoneChart';
import AccelerationChart from './AccelerationChart';
import MagnetometerChart from './MagnetometerChart';
import BatteryChart from './BatteryChart';
import GsmChart from './GsmChart';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement
);// ... existing code ...

// Debug: afișează valoarea variabilei de mediu
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

// Funcție helper pentru formatarea timestamp-ului din DB cu ajustare +3h (GMT+3)
function formatTimestampFromDB(timestamp) {
  if (!timestamp) return '-';
  
  // Parsează direct string-ul din DB (ex: "2025-09-16 17:09:34" sau "2025-09-16T17:09:34.000000Z")
  let dateStr = timestamp;
  
  // Dacă e în format ISO, extrage doar partea de dată și oră
  if (dateStr.includes('T')) {
    dateStr = dateStr.split('T')[0] + ' ' + dateStr.split('T')[1].split('.')[0];
  }
  
  // Parsează YYYY-MM-DD HH:MM:SS
  const [datePart, timePart] = dateStr.split(' ');
  const [year, month, day] = datePart.split('-');
  const [hour, minute, second] = timePart.split(':');
  
  // Creează data și adaugă +3 ore (GMT+3)
  const date = new Date(year, month - 1, day, hour, minute, second);
  date.setHours(date.getHours() + 3);
  
  // Formatează cu AM/PM
  const dateFormatted = date.toLocaleDateString('en-US');
  const timeFormatted = date.toLocaleTimeString('en-US', { hour12: true });
  
  return `${dateFormatted}, ${timeFormatted}`;
}

const API_URL = (process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/get-device-data';

// Componenta AnimatedMarker a fost eliminată - nu era folosită

// Funcții utilitare pentru viitoare utilizare
function getEventTypeFromAlarm(alarm) {
  try {
    if (!alarm || !alarm.data) return '-';
    const dataObj = typeof alarm.data === 'string' ? JSON.parse(alarm.data) : alarm.data;
    return dataObj && dataObj.eventType ? dataObj.eventType : '-';
  } catch {
    return '-';
  }
}
function getSeverityColor(severity) {
  const s = Number(severity);
  if (!Number.isFinite(s) || s <= 0) return '#27ae60';
  if (s === 1) return '#f1c40f';
  if (s === 2) return '#e67e22';
  return '#e74c3c';
}
function getSeverityLabel(severity) {
  const s = Number(severity);
  if (!Number.isFinite(s) || s <= 0) return 'normal';
  if (s === 1) return 'low';
  if (s === 2) return 'medium';
  return 'high';
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('Alarm details render error:', error);
  }
  render() {
    if (this.state.hasError) {
      return <div style={{ padding: 20, color: '#e74c3c' }}>Unable to render alarm details</div>;
    }
    return this.props.children;
  }
}
// function getGsmSignalText(value) {
//   if (value === null || value === undefined) return '-';
//   if (value >= -50 && value <= 0) return 'Excellent';
//   if (value >= -70 && value < -50) return 'Good';
//   if (value >= -80 && value < -70) return 'Weak';
//   if (value < -80) return 'Very weak';
//   return '-';
// }

// function BatteryBar({ level }) {
//   if (level === null || level === undefined) return <div style={{height: 16, background: '#eee', borderRadius: 8, width: 80}} />;
//   let color = '#27ae60';
//   if (level < 20) color = '#e74c3c';
//   else if (level < 50) color = '#f39c12';
//   return (
//     <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//       <div style={{
//         width: 80,
//         height: 16,
//         background: '#eee',
//         borderRadius: 8,
//         overflow: 'hidden',
//         border: '1px solid #ccc',
//         position: 'relative'
//       }}>
//         <div style={{
//           width: `${level}%`,
//           height: '100%',
//           background: color,
//           transition: 'width 0.3s'
//         }} />
//       </div>
//       <span style={{ fontWeight: 'bold', color, fontSize: 18 }}>{level}%</span>
//     </div>
//   );
// }

export { formatTimestampFromDB };

export function getLabels(sortedData, interval) {
  if (!sortedData.length) return [];
  const lastDate = new Date(sortedData[sortedData.length - 1].created_at);
  let step = 1;
  if (interval === '5s') step = 5;
  if (interval === '1m') step = 60;
  if (interval === '5m') step = 300;
  return sortedData.map((_, idx, arr) => {
    const secondsAgo = step * (arr.length - 1 - idx);
    const labelDate = new Date(lastDate.getTime() - secondsAgo * 1000);
    return labelDate.toLocaleTimeString();
  });
}

/**
 * Comprimă o imagine base64 pentru a reduce dimensiunea
 * @param {string} base64String - Imaginea base64
 * @param {number} quality - Calitatea compresiei (0-1)
 * @param {number} maxWidth - Lățimea maximă
 * @returns {Promise<string>} - Imaginea comprimată base64
 */
const compressBase64Image = (base64String, quality = 0.6, maxWidth = 800) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Calculăm noile dimensiuni păstrând aspect ratio
      let newWidth = img.width;
      let newHeight = img.height;
      
      if (newWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = (img.height * maxWidth) / img.width;
      }
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      // Desenăm imaginea redimensionată
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      
      // Convertim în base64 cu compresie
      const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
      
      console.log('Image compressed:', {
        originalSize: base64String.length,
        compressedSize: compressedBase64.length,
        compressionRatio: Math.round((1 - compressedBase64.length / base64String.length) * 100) + '%'
      });
      
      resolve(compressedBase64);
    };
    
    img.onerror = () => {
      console.warn('Could not load image for compression');
      resolve(base64String); // Returnăm originalul în caz de eroare
    };
    
    img.src = base64String;
  });
};

function DashboardComponent({ onLogout }) {
  // TOATE state-urile pentru imagini și responsive la început!
  const [imageCache, setImageCache] = useState(new Map());
  const [loadingImages, setLoadingImages] = useState(new Set());
  // const [imageLoading, setImageLoading] = useState(false); // Eliminat - nu era folosit
  const [lastLoadedImageId, setLastLoadedImageId] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [imageRefreshKey, setImageRefreshKey] = useState(Date.now());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  const [showAlarmModal, setShowAlarmModal] = useState(false);
  const [showAlarmDetailsModal, setShowAlarmDetailsModal] = useState(false);
  const [selectedAlarmForDetails, setSelectedAlarmForDetails] = useState(null);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [deviceLogs, setDeviceLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);
  // TOATE state-urile la început!
  const [imeiData, setImeiData] = useState([]);
  const dashboardRef = useRef();
  const microphoneChartRef = useRef(); // ref pentru graficul de microfon
  const [isFullscreen, setIsFullscreen] = useState(false);
  // const navigate = useNavigate(); // Eliminat - nu era folosit
  const [interval] = useState('1s');
  const [alarms, setAlarms] = useState([]);
  const refreshInterval = 1000;
  // const refreshOptions = [ // Eliminat - nu era folosit
  //   { label: '1s', value: 1000 },
  //   { label: '5s', value: 5000 },
  //   { label: '10s', value: 10000 },
  //   { label: '30s', value: 30000 },
  //   { label: '1m', value: 60000 }
  // ];
  
  // State pentru intervalele per parametru
  const [parameterIntervals, setParameterIntervals] = useState({
    microphone: '1s',
    battery: '1s',
    gsm: '1s',
    acceleration: '1s'
  });
  
  // State pentru rate limiting
  const [rateLimited, setRateLimited] = useState(false);
  const [lastError, setLastError] = useState(null);
  
  // State pentru selectorul global de interval
  const [availableIntervals, setAvailableIntervals] = useState([]);
  const [currentGlobalInterval, setCurrentGlobalInterval] = useState(null);
  const [loadingGlobalInterval, setLoadingGlobalInterval] = useState(false);

  // Funcție pentru intervalul global (păstrată pentru compatibilitate)
  // const handleIntervalChange = async (opt) => {
  //   setIntervalValue(opt);
  //   // Mapare pentru valorile trimise către backend
  //   let intervalValue = opt;
  //   if (opt === '1m') intervalValue = 60;
  //   if (opt === '5m') intervalValue = 300;
  //   if (opt === '1s') intervalValue = 1;
  //   if (opt === '5s') intervalValue = 5;
  //   await fetch(`https://api.sentiguard.ai/api/set-interval?interval=${intervalValue}`);
  // };

  // const handleParameterIntervalChange = async (parameter, opt) => { // Eliminat - nu era folosit
  //   // Mapare pentru valorile trimise către backend
  //   let intervalValue = opt;
  //   if (opt === '1m') intervalValue = 60;
  //   if (opt === '5m') intervalValue = 300;
  //   if (opt === '1s') intervalValue = 1;
  //   if (opt === '5s') intervalValue = 5;

  //   // Setează și refreshInterval-ul global pentru fetch
  //   let refreshMs = 1000;
  //   if (opt === '5s') refreshMs = 5000;
  //   if (opt === '1m') refreshMs = 60000;
  //   if (opt === '5m') refreshMs = 300000;
  //   // setRefreshInterval(refreshMs); // Eliminat
    
  //   try {
  //     const response = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api') + '/set-parameter-interval', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         parameter: parameter,
  //         interval: intervalValue
  //         })
  //       });
  //       if (response.ok) {
  //         setParameterIntervals(prev => ({
  //           ...prev,
  //           [parameter]: opt
  //         }));
  //         console.log(`Set ${parameter} interval to ${opt}`);
  //         } else {
  //         console.error('Failed to set parameter interval');
  //         }
  //       } catch (error) {
  //         console.error('Error setting parameter interval:', error);
  //         }
  //       }
  //     };

  // Funcție pentru a obține intervalele disponibile din baza de date
  const fetchAvailableIntervals = async () => {
    try {
              const response = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/available-intervals');
      if (response.ok) {
        const data = await response.json();
        setAvailableIntervals(data.intervals || []);
        setCurrentGlobalInterval(data.current_default);
      }
    } catch (error) {
      console.error('Error fetching available intervals:', error);
    }
  };

  // Funcție pentru a seta intervalul global
  const handleGlobalIntervalChange = async (intervalId) => {
    setLoadingGlobalInterval(true);
    try {
              const response = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/set-global-interval', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          interval_id: intervalId
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        setCurrentGlobalInterval(data.interval);
        // Refresh intervalele disponibile pentru a actualiza default-ul
        await fetchAvailableIntervals();
        console.log('Global interval updated successfully');
      } else {
        console.error('Failed to set global interval');
      }
    } catch (error) {
      console.error('Error setting global interval:', error);
    } finally {
      setLoadingGlobalInterval(false);
    }
  };

  useEffect(() => {
    // Fetch intervalele per parametru din backend
    const fetchParameterIntervals = async () => {
      try {
        const res = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/all-parameter-intervals');
        if (!res.ok) return; // Nu încerca să parsezi dacă nu e ok
        const json = await res.json();
        
        const intervals = {};
        Object.keys(json).forEach(parameter => {
          const defaultInterval = json[parameter].default;
          // Mapare inversă: seconds -> label
          let label = '1s';
          if (defaultInterval === 5) label = '5s';
          if (defaultInterval === 60) label = '1m';
          if (defaultInterval === 300) label = '5m';
          if (defaultInterval === 1) label = '1s';
          intervals[parameter] = label;
        });
        
        setParameterIntervals(intervals);
      } catch (e) {
        console.error('Error fetching parameter intervals:', e);
        // Fallback la intervalele default
        setParameterIntervals({
          microphone: '1s',
          battery: '1s',
          gsm: '1s',
          acceleration: '1s'
        });
      }
    };
    
    fetchParameterIntervals();
    fetchAvailableIntervals(); // Încarcă și intervalele globale
  }, []);

  // (Am șters complet useEffect-ul care conținea funcția fetchData și făcea request la API_URL fără IMEI)

  // useEffect(() => {
  //   let lastFetchTime = 0;
  //   let intervalId;
  //   const MIN_FETCH_INTERVAL = refreshInterval;
  //
  //   const fetchData = async () => {
  //     if (rateLimited) return;
  //     const now = Date.now();
  //     if (now - lastFetchTime < MIN_FETCH_INTERVAL) {
  //       return; // Skip dacă nu au trecut suficiente secunde
  //     }
  //
  //     try {
  //       lastFetchTime = now;
  //       console.log('Fetching data from:', API_URL);
  //       const res = await fetch(`${API_URL}`);
  //
  //       if (res.status === 429) {
  //         console.warn('Rate limit exceeded, waiting before next request');
  //         setRateLimited(true);
  //         setLastError('Rate limit exceeded. Data will refresh automatically.');
  //         setTimeout(() => setRateLimited(false), 60000); // Reset după 1 minut
  //         return; // Nu actualiza datele, așteaptă următoarea încercare
  //       }
  //
  //       if (!res.ok) {
  //         throw new Error(`HTTP error! status: ${res.status}`);
  //       }
  //
  //       const json = await res.json();
  //       console.log('Received data IDs:', json.map(item => item.id));
  //       if (Array.isArray(json) && json.length > 0) {
  //         setImeiData(json);
  //       } else {
  //         setImeiData([]);
  //       }
  //     } catch (e) {
  //       console.error('Error fetching data:', e);
  //       // Nu resetează datele la eroare, păstrează ultimele date valide
  //     }
  //   };
  //
  //   fetchData();
  //   intervalId = setInterval(fetchData, MIN_FETCH_INTERVAL);
  //   return () => clearInterval(intervalId);
  // }, [refreshInterval, rateLimited]); // scoate dependința de interval

  // useEffect(() => { // Eliminat - nu era folosit
  //   let lastFetchTime = 0;
  //   let intervalId;
  //   const MIN_FETCH_INTERVAL = refreshInterval;
    
  //   const fetchData = async () => {
  //     if (rateLimited) return;
  //     const now = Date.now();
  //     if (now - lastFetchTime < MIN_FETCH_INTERVAL) {
  //       return; // Skip dacă nu au trecut suficiente secunde
  //     }
      
  //     try {
  //         lastFetchTime = now;
  //         console.log('Fetching data from:', API_URL);
  //         const res = await fetch(`${API_URL}`);
        
  //         if (res.status === 429) {
  //           console.warn('Rate limit exceeded, waiting before next request');
  //           setRateLimited(true);
  //           setLastError('Rate limit exceeded. Data will refresh automatically.');
  //           setTimeout(() => setRateLimited(false), 60000); // Reset după 1 minut
  //           return; // Nu actualiza datele, așteaptă următoarea încercare
  //         }
        
  //         if (!res.ok) {
  //           throw new Error(`HTTP error! status: ${res.status}`);
  //         }
        
  //         const json = await res.json();
  //         console.log('Received data IDs:', json.map(item => item.id));
  //         if (Array.isArray(json) && json.length > 0) {
  //           setImeiData(json);
  //         } else {
  //           setImeiData([]);
  //         }
  //       } catch (e) {
  //         console.error('Error fetching data:', e);
  //         // Nu resetează datele la eroare, păstrează ultimele date valide
  //       }
  //     };
    
  //     fetchData();
  //     intervalId = setInterval(fetchData, MIN_FETCH_INTERVAL);
  //     return () => clearInterval(intervalId);
  //   }, [selectedImei, refreshInterval]);

  useEffect(() => {
    // Fetch triggered alarms
    let lastAlarmFetchTime = 0;
    const MIN_ALARM_FETCH_INTERVAL = 10000; // 10 secunde între cereri
    
    const fetchAlarms = async () => {
      const now = Date.now();
      if (now - lastAlarmFetchTime < MIN_ALARM_FETCH_INTERVAL) {
        return;
      }
      
      try {
        lastAlarmFetchTime = now;
        const res = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/triggered-alarms');
        
        if (res.status === 429) {
          console.warn('Rate limit exceeded for alarms, waiting before next request');
          setRateLimited(true);
          setLastError('Rate limit exceeded for alarms. Data will refresh automatically.');
          setTimeout(() => setRateLimited(false), 60000); // Reset după 1 minut
          return;
        }
        
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const json = await res.json();
        setAlarms(json);
      } catch (e) {
        console.error('Error fetching alarms:', e);
        // Nu resetează alarmele la eroare
      }
    };
    fetchAlarms();
    const intervalId = setInterval(fetchAlarms, 15000); // Mărește intervalul la 15 secunde
    return () => clearInterval(intervalId);
  }, []);

  // Extrage toate IMEI-urile unice din data și din alarme
  // const imeisFromData = imeiData.map(d => d.imei).filter(Boolean); // Eliminat - nu era folosit
  // const imeisFromAlarms = alarms.map(a => extractImeiFromAlarm(a)).filter(imei => imei && imei !== '-'); // Eliminat - nu era folosit
  // const allImeisCurrent = Array.from(new Set([...imeisFromData, ...imeisFromAlarms])).sort(); // Eliminat - nu era folosit

  // Păstrează toate IMEI-urile apărute vreodată în sesiunea curentă
  // const [allImeisSession, setAllImeisSession] = useState([]); // Eliminat - nu era folosit
  // useEffect(() => {
  //   setAllImeisSession(prev => Array.from(new Set([...prev, ...allImeisCurrent])));
  // }, [allImeisCurrent]);

  // State pentru toate IMEI-urile din baza de date
  const [allImeisDb, setAllImeisDb] = useState([]);

  // Fetch la toate IMEI-urile din DB la inițializare
  useEffect(() => {
            fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/all-imeis')
      .then(res => res.json())
      .then(imeis => {
        setAllImeisDb(Array.isArray(imeis) ? imeis : []);
      });
  }, []);

  const [selectedImei, setSelectedImei] = useState('');
  // Nu se mai setează automat primul IMEI - utilizatorul trebuie să selecteze manual

  // Elimină orice useEffect sau fetch la /get-device-data fără parametru IMEI
  // (codul pentru fetch cu selectedImei este deja implementat mai sus)

  // ELIMINĂ ACEST useEffect - nu mai este necesar
  // useEffect(() => {
  //   if (!selectedImei) return;
  //   setLoadingImei(true);
  //   fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api') + '/get-device-data?imei=' + encodeURIComponent(selectedImei))
  //     .then(res => res.json())
  //     .then(data => {
  //       setImeiData(Array.isArray(data) ? data : []);
  //       setLoadingImei(false);
  //     })
  //     .catch(() => setLoadingImei(false));
  // }, [selectedImei]);

  // Datele pentru grafice (ordonate crescător după created_at)
  const chartData = React.useMemo(() => imeiData.slice().reverse(), [imeiData]);
  const last = imeiData.length > 0 ? imeiData[0] : null; // cea mai nouă valoare pentru status
  const lastValidImageData = imeiData.find(d => d.image_camera) || null; // cea mai nouă imagine

  // Limita maximă pentru cache-ul de imagini
  const MAX_IMAGE_SIZE_BYTES = 16 * 1024 * 1024; // 16MB
  const MAX_IMAGE_WIDTH = 1200;
  const MAX_IMAGE_HEIGHT = 800;
  const COMPRESS_QUALITY = 0.7;

  // Funcție pentru a preîncărca și cache-ui imaginile
  const preloadImage = React.useCallback(async (imageId) => {
    // Verifică dacă imaginea este deja în cache și validă
    if (imageCache.has(imageId)) {
      const cachedData = imageCache.get(imageId);
      if (cachedData && cachedData.loaded) {
        return cachedData;
      }
    }
    
    // Verifică dacă imaginea este deja în curs de încărcare
    if (loadingImages.has(imageId)) {
      // Așteaptă până când imaginea se termină de încărcat
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (imageCache.has(imageId)) {
            clearInterval(checkInterval);
            const cachedData = imageCache.get(imageId);
            if (cachedData && cachedData.loaded) {
              resolve(cachedData);
            } else {
              reject(new Error('Image loading failed'));
            }
          }
        }, 100);
        
        // Timeout după 10 secunde
        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error('Image loading timeout'));
        }, 10000);
      });
    }
    
    try {
      setLoadingImages(prev => new Set(prev).add(imageId));
      // setImageLoading(true); // Eliminat - nu era folosit
      const img = new Image();
              const imageUrl = `${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai'}/camera-image/${imageId}`;

      // --- NOU: funcție de retry la 429 ---
      const fetchWithRetry = async (url, retries = 20, delay = 2000) => {
        for (let i = 0; i < retries; i++) {
          const response = await fetch(url);
          if (response.status === 429) {
            await new Promise(res => setTimeout(res, delay));
            continue;
          }
          return response;
        }
        throw new Error('Too many retries for camera image');
      };
      
      return new Promise((resolve, reject) => {
        img.onload = async () => {
          try {
            // Înlocuiesc fetch-ul normal cu fetchWithRetry
            const response = await fetchWithRetry(imageUrl);
            const blob = await response.blob();
            if (blob.size > MAX_IMAGE_SIZE_BYTES) {
              // Imaginea e prea mare, nu o afișăm
              setImageCache(new Map([[imageId, { url: imageUrl, loaded: false, error: true, tooLarge: true, size: blob.size, timestamp: Date.now() }]]));
              setLoadingImages(prev => {
                const newSet = new Set(prev);
                newSet.delete(imageId);
                return newSet;
              });
              // setImageLoading(false); // Eliminat - nu era folosit
              reject(new Error('Imaginea depășește 2MB'));
              return;
            }
            // Dacă imaginea e prea mare ca rezoluție, comprim-o
            if (img.naturalWidth > MAX_IMAGE_WIDTH || img.naturalHeight > MAX_IMAGE_HEIGHT) {
              // Convertim blob în base64
              const reader = new FileReader();
              reader.onloadend = async () => {
                const base64String = reader.result;
                const compressedBase64 = await compressBase64Image(base64String, COMPRESS_QUALITY, MAX_IMAGE_WIDTH);
                // Punem imaginea comprimată în cache
                setImageCache(new Map([[imageId, { url: compressedBase64, width: MAX_IMAGE_WIDTH, height: MAX_IMAGE_HEIGHT, loaded: true, compressed: true, timestamp: Date.now() }]]));
                setLoadingImages(prev => {
                  const newSet = new Set(prev);
                  newSet.delete(imageId);
                  return newSet;
                });
                // setImageLoading(false); // Eliminat - nu era folosit
                resolve({ url: compressedBase64, width: MAX_IMAGE_WIDTH, height: MAX_IMAGE_HEIGHT, loaded: true, compressed: true, timestamp: Date.now() });
              };
              reader.readAsDataURL(blob);
              return;
            }
          } catch (e) {
            // Dacă nu putem valida dimensiunea, continuăm normal
          }
          // Imagine validă, nu e prea mare
          const cachedData = {
            url: imageUrl,
            width: img.naturalWidth,
            height: img.naturalHeight,
            loaded: true,
            timestamp: Date.now()
          };
          setImageCache(new Map([[imageId, cachedData]]));
          setLoadingImages(prev => {
            const newSet = new Set(prev);
            newSet.delete(imageId);
            return newSet;
          });
          // setImageLoading(false); // Eliminat - nu era folosit
          resolve(cachedData);
        };
        
        img.onerror = () => {
          // setImageLoading(false); // Eliminat - nu era folosit
          setLoadingImages(prev => {
            const newSet = new Set(prev);
            newSet.delete(imageId);
            return newSet;
          });
          
          // Verifică dacă eroarea este 429 (rate limited)
          if (img.src && img.src.includes('429')) {
            setRateLimited(true);
            setLastError('Rate limit exceeded for camera images');
            // Auto-recovery după 1 minut
            setTimeout(() => {
              setRateLimited(false);
              setLastError(null);
            }, 60000);
          }
          
          // Cache și erorile pentru a evita cererile repetate
          const errorData = {
            url: imageUrl,
            loaded: false,
            error: true,
            timestamp: Date.now()
          };
          setImageCache(prev => new Map(prev).set(imageId, errorData));
          reject(new Error('Failed to load image'));
        };
        
        img.src = imageUrl;
      });
    } catch (error) {
      // setImageLoading(false); // Eliminat - nu era folosit
      // setImageLoading(false); // Eliminat - nu era folosit
      setLoadingImages(prev => {
        const newSet = new Set(prev);
        newSet.delete(imageId);
        return newSet;
      });
      console.error('Error preloading image:', error);
      throw error;
    }
  }, [imageCache, loadingImages, setImageCache, setLoadingImages, setRateLimited, setLastError, MAX_IMAGE_SIZE_BYTES]);

  // Preîncarcă noua imagine când se schimbă
  useEffect(() => {
    if (rateLimited) return;
    // OPTIMIZARE: dacă imaginea e deja în cache și id-ul nu s-a schimbat, nu mai fac nimic (nici fetch, nici setState)
    if (lastValidImageData && lastValidImageData.id === lastLoadedImageId && imageCache.has(lastLoadedImageId)) {
      // Imaginea e deja în cache, nu fac nimic
      return;
    }
    // Dacă imaginea are error: true în cache, nu mai încerc să o încarc
    if (lastValidImageData && imageCache.has(lastValidImageData.id) && imageCache.get(lastValidImageData.id).error) {
      return;
    }
    // Dacă există o imagine nouă, fac fetch și updatez state-ul
    if (lastValidImageData && lastValidImageData.id && lastValidImageData.id !== lastLoadedImageId && !loadingImages.has(lastValidImageData.id)) {
      preloadImage(lastValidImageData.id).then(() => {
        setLastLoadedImageId(lastValidImageData.id);
      }).catch(() => {
        // Ignoră erorile de preîncărcare
      });
    }
  }, [lastValidImageData, lastLoadedImageId, preloadImage, loadingImages, rateLimited, imageCache, selectedImei]);

  // Calculez dacă datele sunt live (ultimul timestamp e în ultimele 10 minute)
  // const isLive = last && (Date.now() - new Date(last.created_at).getTime() < 10 * 60 * 1000);

  // ChartData pentru microfon, memorat ca să nu se re-creeze la fiecare render
  const microphoneChartData = React.useMemo(() => ({
    labels: getLabels(chartData, interval),
      datasets: [{
        label: 'Microphone dB',
        data: chartData.map(d => d.microphone_db),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        pointBackgroundColor: chartData.map((d, i) => i === chartData.length - 1 ? '#e74c3c' : 'rgba(255,99,132,0.5)'),
        pointRadius: chartData.map((d, i) => i === chartData.length - 1 ? 8 : 3),
        pointBorderWidth: chartData.map((d, i) => i === chartData.length - 1 ? 3 : 1),
      }],
  }), [chartData, interval]); // Eliminat selectedImei din dependencies - nu era necesar

  // Actualizez datele direct pe chart fără să re-creez componenta
  useEffect(() => {
    if (microphoneChartRef.current && microphoneChartRef.current.chartInstance) {
      const chart = microphoneChartRef.current.chartInstance;
      chart.data.labels = microphoneChartData.labels;
      chart.data.datasets[0].data = microphoneChartData.datasets[0].data;
      chart.update('none');
    }
  }, [microphoneChartData]);

  // Datele pentru grafice sunt gestionate în componentele individuale
  // const chartData = {
  //   acceleration: {
  //     labels: getLabels(sortedData, interval),
  //     datasets: [{
  //       label: 'Acceleration X',
  //       data: sortedData.map(d => d.motion_sensors?.acceleration_x),
  //       borderColor: 'rgb(54, 162, 235)',
  //       backgroundColor: 'rgba(54, 162, 235, 0.1)',
  //       pointBackgroundColor: sortedData.map((d, i) => i === sortedData.length - 1 ? '#3498db' : 'rgba(54,162,235,0.5)'),
  //       pointRadius: sortedData.map((d, i) => i === sortedData.length - 1 ? 8 : 3),
  //       pointBorderWidth: sortedData.map((d, i) => i === sortedData.length - 1 ? 3 : 1),
  //     }],
  //   },
  //   battery: {
  //     labels: getLabels(sortedData, interval),
  //     datasets: [{
  //       label: 'Battery %',
  //       data: sortedData.map(d => d.battery_level),
  //       borderColor: 'rgb(75, 192, 192)',
  //       backgroundColor: 'rgba(75, 192, 192, 0.1)',
  //       pointBackgroundColor: sortedData.map((d, i) => i === sortedData.length - 1 ? '#27ae60' : 'rgba(75,192,192,0.5)'),
  //       pointRadius: sortedData.map((d, i) => i === sortedData.length - 1 ? 8 : 3),
  //       pointBorderWidth: sortedData.map((d, i) => i === sortedData.length - 1 ? 3 : 1),
  //     }],
  //   },
  //   gsm: {
  //     labels: getLabels(sortedData, interval),
  //     datasets: [{
  //       label: 'GSM Signal dBm',
  //       data: sortedData.map(d => d.gsm_signal),
  //       borderColor: 'rgb(255, 205, 86)',
  //       backgroundColor: 'rgba(255, 205, 86, 0.1)',
  //       pointBackgroundColor: sortedData.map((d, i) => i === sortedData.length - 1 ? '#f39c12' : 'rgba(255,205,86,0.5)'),
  //       pointRadius: sortedData.map((d, i) => i === sortedData.length - 1 ? 8 : 3),
  //       pointBorderWidth: sortedData.map((d, i) => i === sortedData.length - 1 ? 3 : 1),
  //     }],
  //   }
  // };

  // const getChartOptions = (label) => ({
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     tooltip: {
  //       enabled: true,
  //     },
  //     annotation: {
  //       annotations: {
  //         lastValueLine: {
  //           type: 'line',
  //           xMin: sortedData.length - 1,
  //           xMax: sortedData.length - 1,
  //           borderColor: '#222',
  //           borderWidth: 2,
  //           borderDash: [6, 6],
  //           label: {
  //             display: true,
  //             content: 'Last value',
  //             position: 'start',
  //             color: '#222',
  //             font: { weight: 'bold' }
  //           }
  //         }
  //       }
  //     },
  //     scales: {
  //       y: {
  //         beginAtZero: false,
  //       },
  //     },
  //   });

  // const submenuOptions = ['1s', '5s', '1m', '5m'];

  // Componenta Section pentru viitoare utilizare
  // const Section = ({ title, value, chartData, color = '#333', lastTimestamp, chartRef, parameter }) => (
  //   <div style={{ 
  //     padding: 12, 
  //     border: '1px solid #ddd', 
  //     borderRadius: 10,
  //     backgroundColor: '#f9f9f9'
  //   }}>
  //     <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: 22, marginBottom: 8, color: color, textTransform: 'uppercase', letterSpacing: 1 }}>
  //       {title}
  //       <span style={{ fontWeight: 'bold', fontSize: 28, color: '#fff', background: color, borderRadius: 10, padding: '2px 12px', verticalAlign: 'middle', display: 'inline-block', boxShadow: `0 0 8px ${color}55`, marginLeft: 16 }}>
  //         {value}
  //       </span>
  //       {/* {isLive && (
  //         <>
  //           <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: '#27ae60', animation: 'pulse 1s infinite', marginLeft: 12 }} />
  //           <span style={{ fontWeight: 'bold', color: '#27ae60', fontSize: 16, marginLeft: 4 }}>LIVE</span>
  //         </>
  //       )} */}
  //     </div>
  //     {lastTimestamp && (
  //       <div style={{ fontSize: 14, color: '#888', marginBottom: 4 }}>
  //         {new Date(lastTimestamp).toLocaleDateString()} {new Date(lastTimestamp).toLocaleTimeString()}
  //       </div>
  //     )}
  //     <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '6px 0 10px 0' }} />
  //     <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
  //       {submenuOptions.map(opt => (
  //         <button
  //           key={opt}
  //           onClick={() => handleParameterIntervalChange(parameter, opt)} // Funcția a fost eliminată
  //           style={{
  //             padding: '3px 10px',
  //             borderRadius: 20,
  //             border: parameterIntervals[parameter] === opt ? '2px solid #27ae60' : '1px solid #bbb',
  //             background: parameterIntervals[parameter] === opt ? '#eaffea' : '#fff',
  //             color: parameterIntervals[parameter] === opt ? '#27ae60' : '#222',
  //             fontWeight: parameterIntervals[parameter] === opt ? 'bold' : 'normal',
  //             fontSize: 13,
  //             cursor: 'pointer',
  //             boxShadow: parameterIntervals[parameter] === opt ? '0 0 0 2px #27ae6055' : '0 1px 2px #eee',
  //             transition: 'all 0.2s',
  //             position: 'relative',
  //             outline: parameterIntervals[parameter] === opt ? 'none' : undefined
  //           }}
  //           tabIndex={-1}
  //           title={`Perioada de colectare pentru ${title}`}
  //         >
  //           {opt}
  //           {parameterIntervals[parameter] === opt && (
  //           <span style={{
  //             position: 'absolute',
  //               top: -8,
  //               right: -8,
  //               width: 16,
  //               height: 16,
  //               borderRadius: '50%',
  //               border: '2px solid #27ae60',
  //               background: '#fff'
  //           }}></span>
  //           )}
  //         </button>
  //       ))}
  //     </div>
  //     <div style={{ height: 120 }}>
  //       <Line ref={chartRef} data={chartData} options={getChartOptions(title)} />
  //     </div>
  //   </div>
  // );

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.15); opacity: 0.7; }
        100% { transform: scale(1); opacity: 1; }
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  const handleFullscreen = () => {
    const elem = dashboardRef.current;
    if (!isFullscreen) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullscreen(!!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      ));
    };
    document.addEventListener('fullscreenchange', onFullScreenChange);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange);
    document.addEventListener('mozfullscreenchange', onFullScreenChange);
    document.addEventListener('MSFullscreenChange', onFullScreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', onFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
      document.removeEventListener('mozfullscreenchange', onFullScreenChange);
      document.removeEventListener('MSFullscreenChange', onFullScreenChange);
    };
  }, []);

  // const alarmActive = alarms.length > 0;
  // const alarmType = alarmActive ? alarms.map(a => a.tip).join(', ') : '—';
  // const eventsType = alarmActive ? alarms.map(a => a.scenariu).join(', ') : '—';
  // const statusColor = alarmActive ? '#e74c3c' : '#27ae60';
  // const statusText = alarmActive ? 'ALARM' : 'NORMAL';

  // Funcție utilitară pentru a extrage IMEI-ul dintr-o alarmă (din declansatori sau direct)
  function extractImeiFromAlarm(alarm) {
    if (alarm.imei && alarm.imei !== '-') return alarm.imei;
    try {
      const decl = typeof alarm.declansatori === 'string' ? JSON.parse(alarm.declansatori) : alarm.declansatori;
      if (Array.isArray(decl)) {
        // Dacă e array, caută obiect cu imei
        const found = decl.find(obj => obj.imei);
        if (found && found.imei) return found.imei;
      } else if (decl && decl.imei) {
        return decl.imei;
      }
    } catch {}
    return '-';
  }

  // 2. Filtrează alarmele după IMEI selectat și tip (Socket.IO vs normale)
  const filteredAlarms = React.useMemo(() => {
    let filtered = alarms;
    
    // Filtrează după IMEI dacă nu e 'all'
    if (selectedImei !== 'all') {
    const deviceDataForImei = imeiData.filter(d => d.imei === selectedImei);
    const deviceDataIds = deviceDataForImei.map(d => d.id);
      filtered = alarms.filter(a => {
      const alarmImei = extractImeiFromAlarm(a);
      // Dacă alarma are id_device_data, verifică și după id
      if (a.device_data_id && deviceDataIds.includes(a.device_data_id)) return true;
      // Altfel, verifică după IMEI
      return alarmImei === selectedImei;
    });
    }
    
    return filtered;
  }, [alarms, selectedImei, imeiData]);

  // Filtrează alarmele din Socket.IO (settings_alarm_id = 0)
  const socketAlarms = React.useMemo(() => {
    return filteredAlarms.filter(a => a.settings_alarm_id === 0);
  }, [filteredAlarms]);

  // Filtrează alarmele normale (settings_alarm_id != 0)
  const normalAlarms = React.useMemo(() => {
    return filteredAlarms.filter(a => a.settings_alarm_id !== 0);
  }, [filteredAlarms]);

  // Sortare alarme filtrate după data declanșării
  const sortedFilteredAlarms = React.useMemo(() => {
    return [...filteredAlarms].sort((a, b) => {
      const dateA = new Date(a.triggered_at || a.created_at);
      const dateB = new Date(b.triggered_at || b.created_at);
      return dateB.getTime() - dateA.getTime();
    });
  }, [filteredAlarms]);

  // Status device doar pentru IMEI-ul selectat
  // Include alarmele cu settings_alarm_id = 0 (Socket.IO) în afișarea Active Alarms
  const alarmActiveForSelectedImei = socketAlarms.length > 0 || normalAlarms.length > 0;
  const statusColor = alarmActiveForSelectedImei ? '#e74c3c' : '#27ae60';
  const statusText = alarmActiveForSelectedImei ? 'ALARM' : 'NORMAL';

  // 3. Găsește ultima alarmă ACTIVĂ pentru IMEI-ul selectat
  const lastAlarm = React.useMemo(() => {
    // Filtrează doar alarmele active (status !== 'closed' sau status === 'active')
    const activeSocketAlarms = socketAlarms.filter(a => !a.status || a.status === 'active');
    const activeNormalAlarms = normalAlarms.filter(a => !a.status || a.status === 'active');
    const allActiveAlarms = [...activeSocketAlarms, ...activeNormalAlarms];
    return allActiveAlarms.length > 0 ? allActiveAlarms[0] : null;
  }, [socketAlarms, normalAlarms]);

  const closeSingleAlarm = async (id) => {
            await fetch(`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai'}/close-triggered-alarm/${id}`, { method: 'POST' });
        const res = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/triggered-alarms');
    const updatedAlarms = await res.json();
    setAlarms(updatedAlarms);
    // Dacă nu mai sunt alarme active, închide modalul
    if (updatedAlarms.filter(a => a.status === 'active').length === 0) {
      setShowAlarmModal(false);
    }
  };

  const closeAllAlarms = async () => {
            await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/close-all-triggered-alarms', { method: 'POST' });
        const res = await fetch((process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai') + '/triggered-alarms');
    setAlarms(await res.json());
    setShowAlarmModal(false); // Închide modalul după ce se închid toate
  };

  // Funcție pentru a deschide detaliile unei alarme
  const openAlarmDetails = (alarm) => {
    setSelectedAlarmForDetails(alarm);
    setShowAlarmDetailsModal(true);
  };

  // Funcție pentru a închide modulul de detalii
  const closeAlarmDetails = () => {
    setShowAlarmDetailsModal(false);
    setSelectedAlarmForDetails(null);
  };

  // Funcție pentru a deschide modalul cu lista de loguri
  const openLogsModal = async (deviceId) => {
    const targetDeviceId = deviceId || selectedImei;
    if (!targetDeviceId) {
      alert('Nu este selectat niciun device!');
      return;
    }

    setShowLogsModal(true);
    setLoadingLogs(true);
    setDeviceLogs([]);

    try {
      // Obține lista de loguri pentru device-ul selectat
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/list?device_id=${encodeURIComponent(targetDeviceId)}&limit=100`);
      
      if (!response.ok) {
        throw new Error('Eroare la obținerea listei de loguri');
      }

      const data = await response.json();
      
      if (data.success && data.data) {
        // Sortează logurile după data creării (cel mai recent primul)
        const sortedLogs = data.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setDeviceLogs(sortedLogs);
      } else {
        setDeviceLogs([]);
      }
    } catch (error) {
      console.error('Eroare la încărcarea logurilor:', error);
      alert('Eroare la încărcarea logurilor: ' + error.message);
      setDeviceLogs([]);
    } finally {
      setLoadingLogs(false);
    }
  };

  // Funcție pentru descărcarea logurilor unui device
  const downloadDeviceLogs = async (deviceId) => {
    const targetDeviceId = deviceId || selectedImei;
    if (!targetDeviceId) {
      alert('Nu este selectat niciun device!');
      return;
    }

    try {
      // Obține lista de loguri pentru device-ul selectat
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/list?device_id=${encodeURIComponent(targetDeviceId)}&limit=100`);
      
      if (!response.ok) {
        throw new Error('Eroare la obținerea listei de loguri');
      }

      const data = await response.json();
      
      if (!data.success || !data.data || data.data.length === 0) {
        alert('Nu există loguri pentru acest device!');
        return;
      }

      // Descarcă fiecare log
      for (const log of data.data) {
        try {
          const downloadUrl = `${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/download/${encodeURIComponent(log.file_name)}?device_id=${encodeURIComponent(targetDeviceId)}`;
          
          // Creează un link temporar pentru descărcare
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = log.file_name;
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Pauză mică între descărcări pentru a evita rate limiting
          await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
          console.error(`Eroare la descărcarea log-ului ${log.file_name}:`, error);
        }
      }

      alert(`Descărcare inițiată pentru ${data.data.length} loguri!`);
    } catch (error) {
      console.error('Eroare la descărcarea logurilor:', error);
      alert('Eroare la descărcarea logurilor: ' + error.message);
    }
  };

  // DEBUG: vezi ce conține filteredAlarms și selectedImei
  useEffect(() => {
    console.log('selectedImei:', selectedImei, 'filteredAlarms:', filteredAlarms);
  }, [selectedImei, filteredAlarms]);

  // Elimin toate console.log-urile de debug pentru imagini și date

  // Adaugă după celelalte state
  useEffect(() => {
    const interval = setInterval(() => {
      setImageRefreshKey(Date.now());
    }, 5000); // 5 secunde
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 800);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // === NOU: Toate graficele folosesc aceleași date ===
  const microphoneData = imeiData;
  const accelerationData = imeiData;
  const batteryData = imeiData;
  const gsmData = imeiData;

  // === Handleri interval (o singură variantă, goală) ===
  const handleMicrophoneIntervalChange = () => {};
  const handleAccelerationIntervalChange = () => {};

  const handleMagnetometerIntervalChange = () => {};
  const handleBatteryIntervalChange = () => {};
  const handleGsmIntervalChange = () => {};

  // Un singur fetch periodic pentru imeiData (doar pentru IMEI-ul selectat)
  useEffect(() => {
    if (!selectedImei) return;
    const abortController = new AbortController();
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_URL}?imei=${encodeURIComponent(selectedImei)}`, { signal: abortController.signal });
        if (!res.ok) return;
        const data = await res.json();
        setImeiData(Array.isArray(data) ? data : []);
      } catch (err) {
        if (err.name === 'AbortError') return;
      }
    };
    fetchData();
    const intervalId = setInterval(fetchData, refreshInterval);
    return () => {
      abortController.abort();
      clearInterval(intervalId);
    };
  }, [selectedImei, refreshInterval]);

  // 4. Transmit datele și handlerii ca prop la fiecare grafic
  return (
    <div
      ref={dashboardRef}
      style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: '#f1f5f9',
      overflowY: 'auto',
      transition: 'box-shadow 0.2s, background 0.2s',
      boxShadow: 'none',
      background: '#f1f5f9'
      }}
    >
      <header style={{
        textAlign: 'center',
        fontSize: isMobile ? 22 : 32,
        fontWeight: 'bold',
        padding: isMobile ? '10px 50px' : '0 30px',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        color: 'white',
        flex: '0 0 auto',
        position: 'relative',
        height: isMobile ? 'auto' : 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,.25)',
        borderBottom: '1px solid rgba(255,255,255,.06)'
      }}>
        <span style={{ fontSize: isMobile ? 18 : 22, fontWeight: 800, letterSpacing: '.5px', color: '#f8fafc' }}>
          Sentinel Dashboard
        </span>
        {/* Stânga: Settings + Logout */}
        {!isFullscreen && (
          <div style={{ position: 'absolute', left: isMobile ? 8 : 20, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 8, zIndex: 10 }}>
            <a
              href="/settings"
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: isMobile ? '5px 8px' : '6px 14px',
                background: 'rgba(255,255,255,.1)',
                border: '1px solid rgba(255,255,255,.15)',
                borderRadius: 8,
                color: '#94a3b8',
                textDecoration: 'none',
                fontSize: isMobile ? 12 : 13,
                fontWeight: 600,
                transition: 'all .2s',
              }}
              onMouseOver={e => { e.currentTarget.style.background='rgba(255,255,255,.18)'; e.currentTarget.style.color='#fff'; }}
              onMouseOut={e => { e.currentTarget.style.background='rgba(255,255,255,.1)'; e.currentTarget.style.color='#94a3b8'; }}
              title="Alarm settings"
            >
              <FaCog style={{ fontSize: isMobile ? 14 : 15 }} />
              {!isMobile && 'Settings'}
            </a>
            <button
              onClick={onLogout}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: isMobile ? '5px 8px' : '6px 14px',
                background: 'rgba(239,68,68,.15)',
                border: '1px solid rgba(239,68,68,.3)',
                borderRadius: 8,
                color: '#fca5a5',
                fontSize: isMobile ? 12 : 13,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all .2s',
              }}
              onMouseOver={e => { e.currentTarget.style.background='rgba(239,68,68,.3)'; e.currentTarget.style.color='#fff'; }}
              onMouseOut={e => { e.currentTarget.style.background='rgba(239,68,68,.15)'; e.currentTarget.style.color='#fca5a5'; }}
              title="Logout"
            >
              {isMobile ? '✕' : 'Logout'}
            </button>
          </div>
        )}
        {/* Dreapta: Interval selector + Fullscreen */}
        <div style={{ position: 'absolute', right: isMobile ? 8 : 20, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 8, zIndex: 10 }}>
          {/* Selector global pentru interval */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ color: 'rgba(255,255,255,.5)', fontSize: isMobile ? 11 : 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.4px' }}>
              {isMobile ? 'Intv:' : 'Interval:'}
            </span>
            <select
              value={currentGlobalInterval?.id || ''}
              onChange={(e) => handleGlobalIntervalChange(parseInt(e.target.value))}
              disabled={loadingGlobalInterval}
              style={{
                padding: isMobile ? '4px 6px' : '5px 10px',
                fontSize: isMobile ? 11 : 13,
                borderRadius: 7,
                border: '1px solid rgba(255,255,255,.15)',
                background: 'rgba(255,255,255,.1)',
                color: '#f1f5f9',
                fontWeight: 600,
                cursor: loadingGlobalInterval ? 'not-allowed' : 'pointer',
                opacity: loadingGlobalInterval ? 0.6 : 1,
              }}
              title="Select global interval for all charts"
            >
              {availableIntervals.map(interval => (
                <option key={interval.id} value={interval.id} style={{ background: '#1e293b', color: '#f1f5f9' }}>
                  {interval.interval_seconds === 1 ? '1s' :
                   interval.interval_seconds === 5 ? '5s' :
                   interval.interval_seconds === 10 ? '10s' :
                   interval.interval_seconds === 30 ? '30s' :
                   interval.interval_seconds === 60 ? '1m' :
                   interval.interval_seconds === 300 ? '5m' :
                   interval.interval_seconds === 900 ? '15m' :
                   interval.interval_seconds === 1800 ? '30m' :
                   interval.interval_seconds === 3600 ? '1h' :
                   `${interval.interval_seconds}s`}
                  {interval.default ? ' (Default)' : ''}
                </option>
              ))}
            </select>
          </div>
          <button
          onClick={handleFullscreen}
          style={{
            background: isFullscreen ? 'rgba(239,68,68,.2)' : 'rgba(16,185,129,.2)',
            color: isFullscreen ? '#fca5a5' : '#6ee7b7',
            border: `1px solid ${isFullscreen ? 'rgba(239,68,68,.4)' : 'rgba(16,185,129,.4)'}`,
            borderRadius: 8,
            padding: isMobile ? '5px 8px' : '6px 14px',
            fontSize: isMobile ? 12 : 13,
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: 'none',
            transition: 'background 0.2s',
            zIndex: 10
          }}
          title={isFullscreen ? 'Ieși din full screen' : 'Full screen'}
        >
          {isMobile ? (isFullscreen ? 'Exit' : 'Full') : (isFullscreen ? 'Exit Full Screen' : 'Full Screen')}
          </button>
        </div>
      </header>
      {isMobile ? (
        // === LAYOUT MOBIL ===
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: 6, minHeight: 0 }}>
          {/* Device Status + Alarms (mobile) */}
          <div style={{ marginBottom: 12 }}>
            <div className="device-status-card" style={{ marginBottom: 10 }}>
              <FaCheckCircle style={{ color: statusColor, fontSize: 20, flexShrink: 0 }} />
              <select
                value={selectedImei}
                onChange={e => setSelectedImei(e.target.value)}
                className="device-imei-select"
                style={{ fontSize: 12 }}
                title="Selectează IMEI"
              >
                {allImeisDb.map(imei => (
                  <option key={imei} value={imei}>{`IMEI: ${imei}`}</option>
                ))}
              </select>
              <span className={`status-badge ${alarmActiveForSelectedImei ? 'alarm' : 'normal'}`} style={{ fontSize: 11 }}>
                {statusText}
              </span>
              <button onClick={() => openLogsModal(selectedImei)} className="btn btn-primary btn-sm" style={{ fontSize: 11 }}>📋 Logs</button>
              {lastAlarm && (
                <span className="last-alarm-chip" style={{ fontSize: 11 }}>
                  <FaBell style={{ fontSize: 10 }} />
                  {getEventTypeFromAlarm(lastAlarm)}
                </span>
              )}
              {rateLimited && <span className="rate-limit-chip" style={{ fontSize: 11 }} title={lastError}>⚠️ Rate</span>}
            </div>

            <div className={`alarm-panel ${alarmActiveForSelectedImei ? 'active' : 'quiet'}`} style={{ marginBottom: 10 }}>
              <div className={`alarm-panel-header ${alarmActiveForSelectedImei ? '' : 'quiet'}`}>
                <span className={`alarm-panel-title ${alarmActiveForSelectedImei ? 'active' : 'quiet'}`} style={{ fontSize: 12 }}>
                  <FaBell style={{ fontSize: 11 }} />
                  {alarmActiveForSelectedImei ? 'Active Alarms' : 'No Active Alarms'}
                </span>
                {alarmActiveForSelectedImei && (
                  <div style={{ display: 'flex', gap: 6 }}>
                    {sortedFilteredAlarms.length > 1 && (
                      <button onClick={() => setShowAlarmModal(true)} className="btn btn-primary btn-sm" style={{ fontSize: 11 }}>All ({sortedFilteredAlarms.length})</button>
                    )}
                    <button onClick={closeAllAlarms} className="btn btn-danger btn-sm" style={{ fontSize: 11 }}>Close All</button>
                  </div>
                )}
              </div>
              {alarmActiveForSelectedImei ? (
                <div>
                  {sortedFilteredAlarms.slice(0, 1).map(alarm => {
                    const imei = extractImeiFromAlarm(alarm);
                    const ora = alarm.triggered_at || alarm.created_at;
                    return (
                      <div key={alarm.id} className="alarm-item">
                        <div className="alarm-item-info">
                          <span className="alarm-event-type" style={{ color: getSeverityColor(alarm.severity), fontSize: 13 }}>
                            {alarm.settings_alarm_id === 0 ? `Event: ${getEventTypeFromAlarm(alarm)}` : `${alarm.tip} (${getSeverityLabel(alarm.severity)})`}
                          </span>
                          {alarm.description && (
                            <span style={{ fontSize: 11, color: '#64748b', fontStyle: 'italic' }}>{alarm.description}</span>
                          )}
                          <span className="alarm-meta">{ora ? formatTimestampFromDB(ora) : '-'}</span>
                          <span className="alarm-imei">IMEI: {imei}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
                          {alarm.settings_alarm_id === 0 && (
                            <button onClick={() => openAlarmDetails(alarm)} className="btn btn-primary btn-sm" style={{ fontSize: 11 }}>Details</button>
                          )}
                          <button onClick={() => closeSingleAlarm(alarm.id)} className="btn btn-ghost btn-sm" style={{ fontSize: 11 }}>Close</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ padding: '10px 14px', color: '#10b981', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 5 }}>
                  <FaCheckCircle /> All clear
                </div>
              )}
            </div>
          </div>
          {/* Graficele, unul sub altul */}
          <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}><MicrophoneChart 
  data={microphoneData} 
  interval={parameterIntervals.microphone} 
  last={microphoneData.length > 0 ? microphoneData[0] : null} 
  onIntervalChange={handleMicrophoneIntervalChange}
/></div>
          <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}><AccelerationChart 
  data={accelerationData} 
  interval={parameterIntervals.acceleration} 
  last={accelerationData.length > 0 ? accelerationData[0] : null} 
  onIntervalChange={handleAccelerationIntervalChange}
/></div>

          <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}><MagnetometerChart 
  data={accelerationData} 
  interval={parameterIntervals.magnetometer || '1s'} 
  last={accelerationData.length > 0 ? accelerationData[0] : null} 
  onIntervalChange={handleMagnetometerIntervalChange}
/></div>
          <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}><BatteryChart 
  data={batteryData} 
  interval={parameterIntervals.battery} 
  last={batteryData.length > 0 ? batteryData[0] : null} 
  onIntervalChange={handleBatteryIntervalChange}
/></div>
          <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}><GsmChart 
  data={gsmData} 
  interval={parameterIntervals.gsm} 
  last={gsmData.length > 0 ? gsmData[0] : null} 
  onIntervalChange={handleGsmIntervalChange}
/></div>
          {/* Camera Feed mobil */}
          <div className="camera-card" style={{ height: 220, marginBottom: 10 }}>
            <div className="camera-label">
              <span className="camera-live-dot" />
              LIVE CAMERA
            </div>
            {lastValidImageData && !imgError ? (
              <img
                src={`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai'}/camera-image/${lastValidImageData.id}?refresh=${imageRefreshKey}`}
                alt="Camera Feed"
                onError={() => { setImgError(true); setImageCache(prev => new Map(prev).set(lastValidImageData.id, { error: true })); }}
                style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
              />
            ) : (
              <div style={{ width: '100%', height: '100%', background: 'linear-gradient(135deg,#f8fafc,#e2e8f0)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}>
                <div style={{ fontSize: 40 }}>📷</div>
                <span style={{ color: '#94a3b8', fontSize: 13, fontWeight: 600 }}>No camera image available</span>
              </div>
            )}
          </div>
          {/* GPS + Map mobil */}
          <div className="gps-card" style={{ marginBottom: 10 }}>
            <div className="gps-card-header">
              📍 GPS Coordinates
              {last && last.gps && (
                <span style={{ marginLeft: 'auto', fontWeight: 400, fontSize: 12, color: '#475569', textTransform: 'none', letterSpacing: 0 }}>
                  {Number.isFinite(Number(last.gps.lat)) ? Number(last.gps.lat).toFixed(4) : 0}, {Number.isFinite(Number(last.gps.lng)) ? Number(last.gps.lng).toFixed(4) : 0}
                </span>
              )}
            </div>
            {last && last.gps ? (
              <MapContainer center={[Number.isFinite(Number(last.gps.lat)) ? Number(last.gps.lat) : 0, Number.isFinite(Number(last.gps.lng)) ? Number(last.gps.lng) : 0]} zoom={15} style={{ height: 160, width: '100%' }} scrollWheelZoom={false}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
                <Marker position={[Number.isFinite(Number(last.gps.lat)) ? Number(last.gps.lat) : 0, Number.isFinite(Number(last.gps.lng)) ? Number(last.gps.lng) : 0]} />
              </MapContainer>
            ) : (
              <div style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 13 }}>No GPS data available</div>
            )}
          </div>
        </div>
      ) : (
        // === LAYOUT DESKTOP ===
        <div style={{ display: 'flex', flex: 1, padding: '20px 24px', minHeight: 0, gap: 20 }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', minHeight: 0 }}>
            <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}>
              <MicrophoneChart 
                data={microphoneData}
                interval={parameterIntervals.microphone} 
                last={microphoneData.length > 0 ? microphoneData[0] : null}
                onIntervalChange={handleMicrophoneIntervalChange}
              />
            </div>
            <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}>
              <AccelerationChart 
                data={accelerationData}
                interval={parameterIntervals.acceleration} 
                last={accelerationData.length > 0 ? accelerationData[0] : null}
                onIntervalChange={handleAccelerationIntervalChange}
              />
            </div>

            <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}>
              <MagnetometerChart 
                data={accelerationData}
                interval={parameterIntervals.magnetometer || '1s'} 
                last={accelerationData.length > 0 ? accelerationData[0] : null}
                onIntervalChange={handleMagnetometerIntervalChange}
              />
            </div>
            <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}>
              <BatteryChart 
                data={batteryData}
                interval={parameterIntervals.battery} 
                last={batteryData.length > 0 ? batteryData[0] : null}
                onIntervalChange={handleBatteryIntervalChange}
              />
            </div>
            <div style={{ marginBottom: 18, padding: '16px', background: '#ffffff', borderRadius: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.07)' }}>
              <GsmChart 
                data={gsmData}
                interval={parameterIntervals.gsm} 
                last={gsmData.length > 0 ? gsmData[0] : null}
                onIntervalChange={handleGsmIntervalChange}
              />
            </div>
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            overflow: 'hidden'
          }}>
            {/* Device Status Card */}
            <div className="device-status-card" style={{ marginBottom: 10 }}>
              <FaCheckCircle style={{ color: statusColor, fontSize: 22, flexShrink: 0 }} />
              <span style={{ fontSize: 14, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '.4px' }}>Device</span>
              <select
                value={selectedImei}
                onChange={e => setSelectedImei(e.target.value)}
                className="device-imei-select"
                title="Selectează IMEI pentru filtrare"
              >
                {allImeisDb.map(imei => (
                  <option key={imei} value={imei}>{`IMEI: ${imei}`}</option>
                ))}
              </select>
              <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 13, color: '#64748b', fontWeight: 600 }}>Status:</span>
                <span className={`status-badge ${alarmActiveForSelectedImei ? 'alarm' : 'normal'}`}>
                  {statusText}
                </span>
              </span>
              <button
                onClick={() => openLogsModal(selectedImei)}
                className="btn btn-primary btn-sm"
                title="View device logs"
              >
                📋 View Logs
              </button>
              {lastAlarm && extractImeiFromAlarm(lastAlarm) === selectedImei && (
                <span className="last-alarm-chip">
                  <FaBell style={{ fontSize: 12 }} />
                  Last: {getEventTypeFromAlarm(lastAlarm)}
                  <span style={{ fontWeight: 400, opacity: .7 }}> ({lastAlarm.triggered_at ? formatTimestampFromDB(lastAlarm.triggered_at) : '-'})</span>
                </span>
              )}
              {rateLimited && (
                <span className="rate-limit-chip" title={lastError}>⚠️ Rate Limited</span>
              )}
            </div>

            {/* Active Alarms Card */}
            <div className={`alarm-panel ${alarmActiveForSelectedImei ? 'active' : 'quiet'}`} style={{ marginBottom: 14 }}>
              <div className={`alarm-panel-header ${alarmActiveForSelectedImei ? '' : 'quiet'}`}>
                <span className={`alarm-panel-title ${alarmActiveForSelectedImei ? 'active' : 'quiet'}`}>
                  <FaBell style={{ fontSize: 13 }} />
                  {alarmActiveForSelectedImei ? 'Active Alarms' : 'No Active Alarms'}
                </span>
                {alarmActiveForSelectedImei && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    {sortedFilteredAlarms.length > 1 && (
                      <button onClick={() => setShowAlarmModal(true)} className="btn btn-primary btn-sm">
                        See All ({sortedFilteredAlarms.length})
                      </button>
                    )}
                    <button onClick={closeAllAlarms} className="btn btn-danger btn-sm" title="Close all alarms">
                      Close All
                    </button>
                  </div>
                )}
              </div>
              {alarmActiveForSelectedImei ? (
                <div>
                  {sortedFilteredAlarms.slice(0, 1).map(alarm => {
                    const imei = extractImeiFromAlarm(alarm);
                    const ora = alarm.triggered_at || alarm.created_at;
                    return (
                      <div key={alarm.id} className="alarm-item">
                        <div className="alarm-item-info">
                          <span className="alarm-event-type" style={{ color: getSeverityColor(alarm.severity) }}>
                            {alarm.settings_alarm_id === 0
                              ? `Event: ${getEventTypeFromAlarm(alarm)}`
                              : `${alarm.tip} (${getSeverityLabel(alarm.severity)})`}
                          </span>
                          {alarm.description && (
                            <span style={{ fontSize: 12, color: '#64748b', fontStyle: 'italic' }}>{alarm.description}</span>
                          )}
                          <span className="alarm-meta">
                            Triggered: {ora ? formatTimestampFromDB(ora) : '-'}
                          </span>
                          <span className="alarm-imei">IMEI: {imei}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                          {alarm.settings_alarm_id === 0 && (
                            <button onClick={() => openAlarmDetails(alarm)} className="btn btn-primary btn-sm">Details</button>
                          )}
                          <button onClick={() => closeSingleAlarm(alarm.id)} className="btn btn-ghost btn-sm">Close</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ padding: '12px 16px', color: '#10b981', fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <FaCheckCircle /> All clear — no active alarms
                </div>
              )}
            </div>

            {/* Camera Feed */}
            <div className="camera-card" style={{ height: 400, marginBottom: 12 }}>
              <div className="camera-label">
                <span className="camera-live-dot" />
                LIVE CAMERA
              </div>
              {lastValidImageData && !imgError ? (
                <img
                  src={`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai'}/camera-image/${lastValidImageData.id}?refresh=${imageRefreshKey}`}
                  alt="Camera Feed"
                  onError={() => {
                    setImgError(true);
                    setImageCache(prev => new Map(prev).set(lastValidImageData.id, { error: true }));
                  }}
                  style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                />
              ) : (
                <div style={{ width: '100%', height: '100%', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
                  <div style={{ fontSize: 48 }}>📷</div>
                  <span style={{ color: '#94a3b8', fontSize: 14, fontWeight: 600 }}>No camera image available</span>
                </div>
              )}
            </div>

            {/* GPS + Map Card */}
            <div className="gps-card" style={{ marginBottom: 12 }}>
              <div className="gps-card-header">
                📍 GPS Coordinates
                {lastValidImageData && lastValidImageData.gps && (
                  <span style={{ marginLeft: 'auto', fontWeight: 400, fontSize: 13, color: '#475569', textTransform: 'none', letterSpacing: 0 }}>
                    {Number.isFinite(Number(lastValidImageData.gps.lat)) ? Number(lastValidImageData.gps.lat).toFixed(5) : 0},&nbsp;
                    {Number.isFinite(Number(lastValidImageData.gps.lng)) ? Number(lastValidImageData.gps.lng).toFixed(5) : 0}
                  </span>
                )}
              </div>
              <div style={{ padding: 0 }}>
                {lastValidImageData && lastValidImageData.gps ? (
                  <MapContainer center={[Number.isFinite(Number(lastValidImageData.gps.lat)) ? Number(lastValidImageData.gps.lat) : 0, Number.isFinite(Number(lastValidImageData.gps.lng)) ? Number(lastValidImageData.gps.lng) : 0]} zoom={15} style={{ height: 200, width: '100%' }} scrollWheelZoom={false}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
                    <Marker position={[Number.isFinite(Number(lastValidImageData.gps.lat)) ? Number(lastValidImageData.gps.lat) : 0, Number.isFinite(Number(lastValidImageData.gps.lng)) ? Number(lastValidImageData.gps.lng) : 0]} />
                  </MapContainer>
                ) : (
                  <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 14 }}>
                    No GPS data available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showAlarmModal && <AlarmModal
        alarms={sortedFilteredAlarms}
        onClose={() => setShowAlarmModal(false)}
        onSingleClose={closeSingleAlarm}
        onAllClose={closeAllAlarms}
        extractImeiFromAlarm={extractImeiFromAlarm}
        openAlarmDetails={openAlarmDetails}
      />}
      {showAlarmDetailsModal && selectedAlarmForDetails && <ErrorBoundary><AlarmDetailsModal
        alarm={selectedAlarmForDetails}
        onClose={closeAlarmDetails}
        onCloseAlarm={closeSingleAlarm}
      /></ErrorBoundary>}
      {showLogsModal && <LogsModal
        logs={deviceLogs}
        loading={loadingLogs}
        onClose={() => setShowLogsModal(false)}
        deviceId={selectedImei}
      />}
    </div>
  );
}

const AlarmDetailsModal = ({ alarm, onClose, onCloseAlarm }) => {
  const [audioUrl, setAudioUrl] = useState(null);
  const [images, setImages] = useState([]);
  const [gpsData, setGpsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);

  // Parsează datele din alarm
  const alarmData = React.useMemo(() => {
    try {
      return alarm.data ? JSON.parse(alarm.data) : null;
    } catch (e) {
      console.error('Error parsing alarm data:', e);
      return null;
    }
  }, [alarm.data]);

  // Încarcă datele audio și imaginile
  React.useEffect(() => {
    const loadAlarmData = async () => {
      // Debug removed - working properly
      
      if (!alarmData) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Audio and images loading logic
        const baseUrl = process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai';

        // Setează URL-ul direct pentru audio streaming
        // Acceptă atât formatul vechi ({ audio: { path } }) cât și cel nou ({ audioPath })
        const hasAudio = (alarmData.audio && alarmData.audio.path) || alarmData.audioPath;
        if (hasAudio) {
          const audioStreamUrl = `${baseUrl}/socket-audio-simple/${alarm.id}`;
          setAudioUrl(audioStreamUrl);
        }

        // Normalizează lista de imagini pentru ambele formate:
        //  - vechi: images = [{ index: 1 }, ...]
        //  - nou:   imagePaths = ["..._1.jpg", "..._2.jpg", ...]
        let imageEntries = [];
        if (Array.isArray(alarmData.images) && alarmData.images.length > 0) {
          imageEntries = alarmData.images.map((img, i) => ({ index: img.index ?? i + 1 }));
        } else if (Array.isArray(alarmData.imagePaths) && alarmData.imagePaths.length > 0) {
          imageEntries = alarmData.imagePaths.map((path, i) => {
            // Extrage indexul din numele fișierului (..._1.jpg) sau cade pe poziție (1-based)
            const match = /_(\d+)\.[a-z]+$/i.exec(String(path));
            return { index: match ? parseInt(match[1], 10) : i + 1 };
          });
        }

        if (imageEntries.length > 0) {
          const imagePromises = imageEntries.map(async (img) => {
            try {
              const imageUrl = `${baseUrl}/socket-image/${alarm.id}/${img.index}`;
              const imgResponse = await fetch(imageUrl);
              if (imgResponse.ok) {
                const imgBlob = await imgResponse.blob();
                return {
                  index: img.index,
                  url: URL.createObjectURL(imgBlob),
                  available: true
                };
              }
            } catch (e) {
              console.warn(`Could not load image ${img.index}:`, e);
            }
            return {
              index: img.index,
              url: null,
              available: false
            };
          });

          const loadedImages = await Promise.all(imagePromises);
          setImages(loadedImages);
        }

        // Setează datele GPS cu normalizare (lat/lng) – acceptă obiect gps sau câmpuri gpslat/gpslong
        const g = alarmData.gps || {};
        const lat = parseFloat(g.lat ?? g.latitude ?? alarmData.gpslat ?? 0);
        const lng = parseFloat(g.lng ?? g.long ?? g.longitude ?? alarmData.gpslong ?? 0);
        setGpsData({ lat, lng });

      } catch (e) {
        console.error('Error loading alarm data:', e);
        setError('Error loading alarm data');
      } finally {
        setLoading(false);
      }
    };

    loadAlarmData();
  }, [alarmData, alarm.id]);

  // Cleanup URLs când componenta se distruge
  React.useEffect(() => {
    return () => {
      if (audioUrl) URL.revokeObjectURL(audioUrl);
      images.forEach(img => {
        if (img.url) URL.revokeObjectURL(img.url);
      });
    };
  }, [audioUrl, images]);

  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
    zIndex: 1000,
    width: '90%',
    maxWidth: '900px',
    maxHeight: '90vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column'
  };

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '2px solid #e74c3c',
    paddingBottom: '15px',
    marginBottom: '20px'
  };

  const contentStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    flex: 1
  };

  const sectionStyle = {
    backgroundColor: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid #dee2e6'
  };

  const mapStyle = {
    height: '300px',
    width: '100%',
    borderRadius: '8px',
    border: '1px solid #dee2e6'
  };

  return (
    <>
      <div style={backdropStyle} onClick={onClose}></div>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0, fontSize: '24px', color: '#e74c3c' }}>
            🚨 Socket.IO Alarm Details
          </h2>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => {
                onCloseAlarm(alarm.id);
                onClose(); // Închide și fereastra după ce închide alarma
              }}
              style={{
                background: '#e74c3c',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '8px 16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Close Alarm
            </button>
            <button
              onClick={onClose}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '8px 16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              ×
            </button>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '18px', color: '#6c757d' }}>Loading data...</div>
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#e74c3c' }}>
            <div style={{ fontSize: '18px' }}>{error}</div>
          </div>
        ) : (
          <div style={contentStyle}>
            {/* Basic Information */}
            <div style={sectionStyle}>
              <h3 style={{ marginTop: 0, color: '#495057' }}>Alarm Information</h3>
              <p><strong>IMEI:</strong> {alarm.imei || 'N/A'}</p>
              <p><strong>Event Type:</strong> {alarmData?.eventType || 'N/A'}</p>
              <p><strong>Triggered At:</strong> {alarm.triggered_at ? formatTimestampFromDB(alarm.triggered_at) : 'N/A'}</p>
              <p><strong>Status:</strong> {alarm.status || 'active'}</p>
              <p><strong>Severity:</strong> <span style={{ color: getSeverityColor(alarm.severity), fontWeight: 'bold' }}>{getSeverityLabel(alarm.severity)} ({typeof alarm.severity === 'number' ? alarm.severity : 0})</span></p>
              {alarmData?.metadata && (
                <p><strong>Source:</strong> {alarmData.metadata.source || 'N/A'}</p>
              )}
            </div>

            {/* GPS Coordinates */}
            <div style={sectionStyle}>
              <h3 style={{ marginTop: 0, color: '#495057' }}>GPS Coordinates</h3>
              {(gpsData && Number.isFinite(Number(gpsData.lat)) && Number.isFinite(Number(gpsData.lng))) ? (
                <div>
                  <p><strong>Latitude:</strong> {Number(gpsData.lat)}</p>
                  <p><strong>Longitude:</strong> {Number(gpsData.lng)}</p>
                  <div style={{ marginTop: '10px' }}>
                    <MapContainer center={[Number(gpsData.lat), Number(gpsData.lng)]} zoom={15} style={mapStyle}>
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; OpenStreetMap contributors"
                      />
                      <Marker position={[Number(gpsData.lat), Number(gpsData.lng)]} />
                    </MapContainer>
                  </div>
                </div>
              ) : (
                <p style={{ color: '#6c757d' }}>No GPS data available</p>
              )}
            </div>

            {/* Audio */}
            <div style={sectionStyle}>
              <h3 style={{ marginTop: 0, color: '#495057' }}>Audio Recording</h3>
              {audioUrl ? (
                <div>
                  <audio 
                    controls 
                    autoPlay
                    preload="auto" 
                    style={{ width: '100%' }}
                    crossOrigin="anonymous"
                  >
                    <source src={audioUrl} type="audio/wav" />
                    Your browser does not support the audio element.
                  </audio>
                  <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '5px' }}>
                    5-second recording before alarm trigger
                  </p>
                </div>
              ) : (
                <p style={{ color: '#6c757d' }}>Audio recording not available</p>
              )}
            </div>

            {/* Images */}
            <div style={sectionStyle}>
              <h3 style={{ marginTop: 0, color: '#495057' }}>Images</h3>
              {images.length > 0 ? (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
                  {images.map((img, index) => (
                    <div key={index} style={{ textAlign: 'center' }}>
                      {img.available ? (
                        <img
                          src={img.url}
                          alt={`Image ${img.index}`}
                          onClick={() => setLightboxImage(img.url)}
                          style={{
                            width: '100%',
                            height: '120px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            border: '1px solid #dee2e6',
                            cursor: 'zoom-in'
                          }}
                        />
                      ) : (
                        <div style={{
                          width: '100%',
                          height: '120px',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #dee2e6',
                          borderRadius: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#6c757d'
                        }}>
                          Image {img.index} unavailable
                        </div>
                      )}
                      <p style={{ fontSize: '12px', color: '#6c757d', margin: '5px 0 0 0' }}>
                        Image {img.index}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ color: '#6c757d' }}>No images available</p>
              )}
            </div>
          </div>
        )}
      </div>

      {lightboxImage && (
        <div
          onClick={() => setLightboxImage(null)}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            cursor: 'zoom-out'
          }}
        >
          <img
            src={lightboxImage}
            alt="Fullscreen"
            onClick={e => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              borderRadius: '8px',
              boxShadow: '0 4px 32px rgba(0,0,0,0.6)'
            }}
          />
          <button
            onClick={() => setLightboxImage(null)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '30px',
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: '36px',
              cursor: 'pointer',
              lineHeight: 1
            }}
          >
            &times;
          </button>
        </div>
      )}
    </>
  );
};

const AlarmModal = ({ alarms, onClose, onSingleClose, onAllClose, extractImeiFromAlarm, openAlarmDetails }) => {
    // Basic styling for the modal
    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px 40px',
        borderRadius: '10px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
        zIndex: 1000,
        width: '80%',
        maxWidth: '700px',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column'
    };
    const backdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999
    };
    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #eee',
        paddingBottom: '10px',
        marginBottom: '10px'
    };
    const listStyle = {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        overflowY: 'auto',
        flexGrow: 1
    };

    return (
        <>
            <div style={backdropStyle} onClick={onClose}></div>
            <div style={modalStyle}>
                <div style={headerStyle}>
                    <h2 style={{ margin: 0, fontSize: '24px' }}>All Active Alarms</h2>
                    <button onClick={onAllClose} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer' }}>Close All</button>
                </div>
                <ul style={listStyle}>
                    {alarms.map(alarm => {
                        const imei = extractImeiFromAlarm(alarm);
                        let ora = alarm.triggered_at || alarm.created_at;
                        let oraDate = ora ? new Date(ora) : null;
                        return (
                            <li key={alarm.id} style={{ marginBottom: '10px', paddingBottom: '10px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                  {alarm.settings_alarm_id === 0 ? (
                                    <span style={{ color: '#2c3e50', fontSize: 14 }}>Event: {getEventTypeFromAlarm(alarm)}</span>
                                  ) : (
                                    <span style={{ fontWeight: 'bold', color: getSeverityColor(alarm.severity) }}>{alarm.tip} <span style={{ color: getSeverityColor(alarm.severity), fontWeight: 400, marginLeft: 6 }}>(severity: {getSeverityLabel(alarm.severity)} ({typeof alarm.severity === 'number' ? alarm.severity : 0}))</span></span>
                                  )}
                                  {alarm.description && (
                                    <span style={{ fontSize: 12, color: '#64748b', fontStyle: 'italic' }}>{alarm.description}</span>
                                  )}
                                  <span style={{ color: '#888', fontSize: 14 }}> (triggered at {oraDate ? formatTimestampFromDB(ora) : '-'})</span>
                                  <span style={{ color: '#3498db', fontSize: 14 }}>IMEI: {imei}</span>
                                </span>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                  {alarm.settings_alarm_id === 0 && (
                                    <button
                                      onClick={() => openAlarmDetails(alarm)}
                                      style={{ background: '#3498db', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 12px', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}
                                      title="View details"
                                    >
                                      Details
                                    </button>
                                  )}
                                <button
                                  onClick={() => onSingleClose(alarm.id)}
                                    style={{ background: '#bbb', color: '#fff', border: 'none', borderRadius: 6, padding: '4px 12px', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}
                                  title="Close this alarm"
                                >
                                  Close
                                </button>
                                </div>
                            </li>
                        );
                    })}
                </ul>
                <button onClick={onClose} style={{ marginTop: '20px', padding: '10px', cursor: 'pointer' }}>Close Window</button>
            </div>
        </>
    );
};

const LogsModal = ({ logs, loading, onClose, deviceId }) => {
  const modalStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '20px 40px',
    borderRadius: '10px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    zIndex: 1000,
    width: '80%',
    maxWidth: '900px',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column'
  };
  
  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999
  };
  
  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    marginBottom: '10px'
  };
  
  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    overflowY: 'auto',
    flexGrow: 1
  };

  const downloadSingleLog = async (log) => {
    try {
      const downloadUrl = `${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/download/${encodeURIComponent(log.file_name)}?device_id=${encodeURIComponent(log.device_id)}`;
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = log.file_name;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Eroare la descărcarea log-ului ${log.file_name}:`, error);
      alert(`Eroare la descărcarea log-ului: ${error.message}`);
    }
  };

  const deleteSingleLog = async (log) => {
    if (!window.confirm(`Ești sigur că vrei să ștergi log-ul "${log.file_name}"?`)) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/delete/${encodeURIComponent(log.file_name)}?device_id=${encodeURIComponent(log.device_id)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (result.success) {
        alert('Log șters cu succes!');
        // Reîncarcă lista de loguri
        window.location.reload();
      } else {
        alert(`Eroare la ștergerea log-ului: ${result.message}`);
      }
    } catch (error) {
      console.error(`Eroare la ștergerea log-ului ${log.file_name}:`, error);
      alert(`Eroare la ștergerea log-ului: ${error.message}`);
    }
  };

  const uploadLogFile = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Reset input value pentru a permite același fișier să fie încărcat din nou
    event.target.value = '';

    try {
      const formData = new FormData();
      formData.append('log_file', file);
      formData.append('device_id', deviceId);
      formData.append('log_type', 'uploaded');
      formData.append('description', `Uploaded: ${file.name}`);

      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.sentiguard.ai/api'}/logs/upload`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        alert('Log uploadat cu succes!');
        // Reîncarcă lista de loguri
        window.location.reload();
      } else {
        alert(`Eroare la upload: ${result.message}`);
      }
    } catch (error) {
      console.error('Eroare la upload:', error);
      alert(`Eroare la upload: ${error.message}`);
    }
  };

  return (
    <>
      <div style={backdropStyle} onClick={onClose}></div>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0, fontSize: '24px' }}>📋 Device Logs - IMEI: {deviceId}</h2>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <label style={{ background: '#3498db', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
              📤 Upload Log
              <input
                type="file"
                onChange={uploadLogFile}
                style={{ display: 'none' }}
                accept=".txt,.log,.csv,.json"
              />
            </label>
            <button onClick={onClose} style={{ background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer' }}>
              Close
            </button>
          </div>
        </div>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
            <div style={{ fontSize: '18px' }}>Loading logs...</div>
          </div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
            <div style={{ fontSize: '18px' }}>No logs found for this device</div>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '10px', fontSize: '14px', color: '#6c757d' }}>
              Total logs: {logs.length}
            </div>
            <ul style={listStyle}>
              {logs.map(log => (
                <li key={log.id} style={{ marginBottom: '10px', paddingBottom: '10px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 'bold', color: '#333', marginBottom: '4px' }}>
                      {log.file_name}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6c757d' }}>
                      <span>Type: {log.log_type || 'N/A'}</span>
                      <span style={{ marginLeft: '16px' }}>Size: {(log.file_size / 1024).toFixed(2)} KB</span>
                      <span style={{ marginLeft: '16px' }}>Uploaded: {log.uploaded_at ? formatTimestampFromDB(log.uploaded_at) : (log.created_at ? formatTimestampFromDB(log.created_at) : 'N/A')}</span>
                      {log.downloaded_at && (
                        <span style={{ marginLeft: '16px' }}>Downloaded: {formatTimestampFromDB(log.downloaded_at)}</span>
                      )}
                    </div>
                    {log.description && (
                      <div style={{ fontSize: '12px', color: '#495057', marginTop: '2px' }}>
                        {log.description}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
                    <button
                      onClick={() => downloadSingleLog(log)}
                      style={{ background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}
                      title="Download this log"
                    >
                      📥 Download
                    </button>
                    <button
                      onClick={() => deleteSingleLog(log)}
                      style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 'bold', fontSize: 14, cursor: 'pointer' }}
                      title="Delete this log"
                    >
                      🗑️ Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default DashboardComponent; 
